export function cleanupBootstrapModalArtifacts(): void {
  document.body.classList.remove('modal-open');
  document.querySelectorAll('.modal-backdrop').forEach((element) => {
    element.parentNode?.removeChild(element);
  });
}

export function cleanupMuiModalArtifacts(): void {
  document.body.classList.remove('MuiDialog-scrollLock');
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('padding-right');
}

/** Remove artefatos de modal Bootstrap e MUI que travam scroll no body. */
export function cleanupBodyScrollLock(): void {
  cleanupBootstrapModalArtifacts();
  cleanupMuiModalArtifacts();
}
